export type AttendanceAddressLocation = {
  lat?: number;
  lon?: number;
  latitude?: number;
  longitude?: number;
  id?: string;
  name?: string;
  type?: string;
  uid?: string;
};

export type AttendanceAddress = {
  address?: string | null;
  city?: string | null;
  region?: string | null;
  country?: string | null;
  zip?: string | null;
  location?: AttendanceAddressLocation | null;
} | null;

const isBlankText = (value: unknown): boolean =>
  value == null || (typeof value === 'string' && value.trim() === '');

const hasMapCoordinates = (location?: AttendanceAddressLocation | null): boolean => {
  if (!location) {
    return false;
  }

  const lat = location.lat ?? location.latitude;
  const lon = location.lon ?? location.longitude;
  return Number.isFinite(lat) && Number.isFinite(lon);
};

/** True when an address has usable text or map coordinates for attendance. */
export const userHasAttendanceAddress = (address?: AttendanceAddress): boolean => {
  if (!address) {
    return false;
  }

  const hasText =
    !isBlankText(address.address) ||
    !isBlankText(address.city) ||
    !isBlankText(address.region);

  return hasText || hasMapCoordinates(address.location);
};

export const isAttendanceProfileIncomplete = (user: {
  onboardingCompleted?: boolean;
  address?: AttendanceAddress;
}): boolean => user.onboardingCompleted !== false && !userHasAttendanceAddress(user.address);
